import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  VStack, Box, Text, HStack,
} from '@chakra-ui/react';
import { useMICUTheme } from '../../lib/micu/MICUThemeProvider';
import { getDeviceTypeList } from '../../lib/micu/deviceTemplates';
import { addDevice } from '../../lib/micu/micuDatabase';

const DeviceAddModal = ({ isOpen, onClose, caseId, onAdded }) => {
  const navigate = useNavigate();
  const { isDark } = useMICUTheme();
  const deviceTypes = getDeviceTypeList();

  const handleSelect = async (deviceKey) => {
    const id = await addDevice(caseId, deviceKey);
    onClose();
    if (onAdded) onAdded();
    navigate(`/micu-mobile/case/${caseId}/device/${id}`);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={isDark ? 'micu.bgSecondary' : 'micu.bg'} color="micu.text" mx={4}>
        <ModalHeader fontSize="lg">Add Device</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={2} align="stretch">
            {deviceTypes.map(dt => (
              <Box
                key={dt.key}
                p={3}
                border="1px solid"
                borderColor="micu.border"
                borderRadius="md"
                cursor="pointer"
                _hover={{ borderColor: 'micu.teal', bg: isDark ? 'micu.bgTertiary' : 'micu.bgSecondary' }}
                onClick={() => handleSelect(dt.key)}
              >
                <HStack spacing={3}>
                  <Text fontWeight="600" color="micu.text">{dt.name}</Text>
                </HStack>
              </Box>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeviceAddModal;
